module.exports = __webpack_public_path__ + "img/estrella_incompleta.0fc98511.svg";